<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper pt-0">
  <div class="w-100 mb-3">
    <label class="lbl_pos_field">{{'DIVISION.DIVISION_NAME' | translate}}
      <i *ngIf="errorModel!=null && errorModel['Name']!=null"
         class="pi pi-exclamation-circle me-1 mt-1 error_color float-end" pTooltip="{{errorModel['Name']|translate}}"
         tooltipPosition="top"></i>
    </label>
    <input type="text" class="primary_input_field mt-1" [(ngModel)]="divisionModel.name">
  </div>
  <div class="w-100 mb-3">
    <label class="lbl_pos_field">{{'DIVISION.PRINTER_NAME' | translate}}
      <i *ngIf="errorModel!=null && errorModel['PrinterName']!=null"
         class="pi pi-exclamation-circle me-1 mt-1 error_color float-end" pTooltip="{{errorModel['PrinterName']|translate}}"
         tooltipPosition="top"></i>
    </label>
    <input type="text" class="primary_input_field mt-1" [(ngModel)]="divisionModel.printerName">
  </div>
  <div class="w-100 mt-4">
    <button class=" btn-group-text create_btn w-100 " *ngIf="!enableEdit" (click)="addOrUpdateDivision(divisionModel)">
      {{ 'SAVE' | translate}}</button>
    <button class=" btn-group-text create_btn w-100 " *ngIf="enableEdit" (click)="addOrUpdateDivision(divisionModel, true)">
      {{ 'SAVE' | translate}}</button>
  </div>
</div>
